import { Link, useLocation } from "react-router-dom"
import { SquareChevronDown, SquareChevronUp, Bell } from "lucide-react"
import flappyIcon from "../flappy.png"

import { TopnavMarquee } from "./topnav-marquee"
import { TopnavProfileButton } from "./topnav-profile-button"

import { useEffect, useState } from "react"
import {
  getUnreadNotificationsCount,
  subscribeToNotificationChanges,
} from "@/core/notifications/notificationEvents"

import { useNativeVibration } from "@/hooks/useNativeVibration"

type Props = {
  isPortrait: boolean
  isLandscape: boolean
  onOpenQr: () => void
}

export function TopnavActions({
  isPortrait,
  isLandscape,
  onOpenQr,
}: Props) {
  const vibrate = useNativeVibration()

  const location = useLocation()
  
  
  const [hasUnread, setHasUnread] = useState(
    () => getUnreadNotificationsCount() > 0
  )
  useEffect(() => {
    const update = () => {
      setHasUnread(getUnreadNotificationsCount() > 0)
    }
    update()
    return subscribeToNotificationChanges(update)
  }, [])

  //const [user] = useAuthState(auth)

  const userProfilePic =
    localStorage.getItem("profilePic") || null

  return (
    <div className="ml-auto flex items-center gap-3">
      {location.pathname === "/" && (
        <TopnavMarquee />
      )}


          {/* <Link to="/flappy">
            <TopnavProfileButton>
              <img
                src={flappyIcon}
                alt="Flappy"
                className="w-7 h-7 object-contain"
              />
            </TopnavProfileButton>
          </Link> */}

      {location.pathname === "/ajustes" &&
        isPortrait &&
   
          <Link to="/flappy"  onClick={() => vibrate("light")}>
            <TopnavProfileButton>
              <img
                src={flappyIcon}
                alt="Flappy"
                className="w-7 h-7 object-contain"
              />
            </TopnavProfileButton>
          </Link>
        }

      {(location.pathname === "/" ||
        location.pathname === "/radio") && (
        <Link to="/notificaciones"  onClick={() => vibrate("light")}>
          <TopnavProfileButton>
            <div className="relative">
              <Bell className="h-4 w-4" />
        
              {hasUnread && (
                <span
                  className="
                    absolute
                    -right-0.5
                    -top-1
                    h-2
                    w-2
                    rounded-full
                    //bg-red-500
                    bg-[var(--version)] items-center
                    ring-2 justify-center
                    ring-black
                  "
                />
              )}
            </div>
          </TopnavProfileButton>
        </Link>
      )}
      
      {location.pathname === "/notificaciones" && (
        <Link to="/" onClick={() => vibrate("light")}>
          <TopnavProfileButton>
            <div className="relative">
              <Bell className="h-4 w-4" />
      
              {hasUnread && (
                <span
                  className="
                    absolute
                    -right-1
                    -top-1
                    h-2
                    w-2
                    rounded-full
                    bg-red-500
                    ring-2
                    ring-black
                  "
                />
              )}
            </div>
          </TopnavProfileButton>
        </Link>
      )}

      {location.pathname === "/ajustes" ? (
        <TopnavProfileButton
          onClick={onOpenQr}
        >
          <i className="f7-icons">qrcode</i>
        </TopnavProfileButton>
      ) : (
        <Link
          to={
            location.pathname === "/library"
              ? "/buscar"
              : location.pathname === "/u"
              ? "/u/custom"
              : userProfilePic
              ? "/u"
              : "/u/custom"
          }  onClick={() => vibrate("light")}
        >
          <TopnavProfileButton  onClick={() => vibrate("light")}>
            {location.pathname === "/library" ? (
              <i className="f7-icons">
                search_fill
              </i>
            ) : location.pathname === "/u" ? (
              <i className="f7-icons">
                info_circle
              </i>
            ) : userProfilePic ? (
              <img
                src={userProfilePic}
                alt="Perfil"
                className="
                  w-full
                  h-full
                  rounded-xl
                  object-cover
                "
              />
            ) : (
              <i className="f7-icons">
                person
              </i>
            )}
          </TopnavProfileButton>
        </Link>
      )}

      {location.pathname === "/" &&
        isLandscape && (
          <>
            <Link to="/offline">
              <button
                className="
                  h-9 px-4
                  rounded-[.5rem]
                  bg-white/15
                  hover:bg-white/20
                  text-xs
                  opacity-80 text-[var(--primary-color)]
                  font-semibold
                  flex items-center gap-2
                  transition-all
                "
              >
                {/* <i className="f7-icons">
                  arrow_down_circle_fill
                </i> */}
                <SquareChevronDown className="w-5 h-5" />

                DESCARGAS
              </button>
            </Link>

            <Link to="/subir">
              <button
                className="
                  h-9 px-4
                  rounded-[.5rem]
                  bg-white/90
                  hover:bg-white
                  text-xs
                  text-black
                  font-semibold
                  flex items-center gap-2
                  transition-all
                "
              >
                <SquareChevronUp className="w-5 h-5" />

                PUBLICAR
              </button>
            </Link>
          </>
        )}
    </div>
  )
}